<form [formGroup]="specWUOFormGroup">
        <div formGroupName="specificatieWUO">
            <div formGroupName="opbouw">
                    <div class="row">
                        <div class="col col-1">
                            <p>Winst uit onderneming</p>
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    formControlName="fiscaleWinstMinusOAenMkbWv"
                                    id="fiscaleWinstMinusOAenMkbWv"
                                    class="custom-input-150"
                                    [decimals]="0"
                                    align="right"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                        <div class="col-4"></div>
                    </div>
                </div>
            </div>
</form>
